import { Sparkle } from "lucide-react";

const ITEMS = [
    "Musica dal vivo",
    "Birre & cocktail",
    "Giardino sul prato",
    "Veranda coperta",
    "Hamburger & panini",
    "Dalla sera a notte fonda",
    "Est. 1997",
];

export const Marquee = () => (
    <div
        className="marquee border-y border-bordo bg-carbone"
        data-testid="marquee-band"
        role="region"
        aria-label="Punti di forza del River Pub"
    >
        <div className="marquee-track py-4">
            {[0, 1].map((copy) => (
                <ul key={copy} className="flex items-center shrink-0" aria-hidden={copy === 1}>
                    {ITEMS.map((it) => (
                        <li
                            key={it}
                            className="flex items-center gap-6 pr-6 font-heading uppercase tracking-[0.18em] text-sm text-avorio/70 whitespace-nowrap"
                        >
                            {it}
                            <Sparkle className="w-3.5 h-3.5 text-ambra shrink-0" strokeWidth={1.5} aria-hidden="true" />
                        </li>
                    ))}
                </ul>
            ))}
        </div>
    </div>
);
